import { Button, Empty, Spin } from "antd";
import { usePoster } from "../../hooks/usePoster";
import { StyledPoster } from "./styles";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useEffect, useMemo, useState } from "react";
import PosterContent from "./PosterContent";
import { convertDateToFromNow } from "../../utils/dayjs";

const Poster = () => {
  const { posters, allFetched, fetchPosters, loading } = usePoster();
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectedPoster = useMemo(
    () => posters[selectedIndex],
    [posters, selectedIndex],
  );

  useEffect(() => {
    if (!loading && posters?.length - 1 < selectedIndex) {
      setSelectedIndex(0);
    }
  }, [loading]);

  return (
    <StyledPoster>
      {loading ? (
        <div className="flex-center loading">
          <Spin />
        </div>
      ) : !posters?.length ? (
        <div className="no-found flex-center">
          <Empty description="No Latest Posters Found" />
        </div>
      ) : (
        <div style={{ width: "100%", height: "100%" }}>
          {selectedPoster && (
            <PosterContent poster={selectedPoster} key={selectedPoster?.id} />
          )}

          {selectedPoster && (
            <div className="styled-overlay">
              {posters.length > 1 && (
                <div className="progress-row">
                  {posters.map((_, i) => (
                    <span
                      key={i}
                      className={`cursor-pointer ${
                        i === selectedIndex
                          ? "active"
                          : i < selectedIndex
                            ? "past"
                            : ""
                      }`}
                      onClick={() => setSelectedIndex(i)}
                    />
                  ))}
                </div>
              )}
              <div className="meta-row">
                <div className="avatar">
                  {selectedPoster.tenant_name
                    ?.split(" ")
                    .map((w) => w[0])
                    .slice(0, 2)
                    .join("")}
                </div>
                <div className="text-block">
                  <span className="tenant-name">
                    {selectedPoster.tenant_name}
                  </span>
                  <span className="time-ago">
                    {convertDateToFromNow(selectedPoster.created_at)}
                  </span>
                </div>
              </div>
            </div>
          )}

          {selectedIndex > 0 && (
            <Button
              className="left-btn"
              icon={<LeftOutlined />}
              shape="round"
              type="primary"
              onClick={() => setSelectedIndex(selectedIndex - 1)}
            />
          )}

          {(selectedIndex < posters.length - 1 || !allFetched) && (
            <Button
              className="right-btn"
              icon={<RightOutlined />}
              shape="round"
              type="primary"
              onClick={() => {
                const nextIndex = selectedIndex + 1;

                if (nextIndex >= posters.length && !allFetched) fetchPosters();

                setSelectedIndex(nextIndex);
              }}
            />
          )}
        </div>
      )}
    </StyledPoster>
  );
};

export default Poster;
